module.exports = __webpack_public_path__ + "img/Location_Minnetonka.2cc9428f.png";